const screenInputData = {
  ReportsRefferalCustomerDetailing: [{"name":"ShippingNumber","type":"String","cardinality":1,"isExpandedPanel":null}],
	EndOfSProductFourthWeb: [{"name":"ProductAttribute02","type":"String","cardinality":1,"isExpandedPanel":null},{"name":"ProductAttribute03","type":"String","cardinality":1,"isExpandedPanel":null},{"name":"ColorCode","type":"String","cardinality":1,"isExpandedPanel":null}],
	ProductListDesignWeb: [{"name":"ProductAttribute02","type":"String","cardinality":1,"isExpandedPanel":null}],
	EndOfProductDesignWeb: [{"name":"ProductAttribute02","type":"String","cardinality":1,"isExpandedPanel":null}],
	ReportsCustomerSalesDetail: [{"name":"orderNumber","type":"String","cardinality":1,"isExpandedPanel":null}],
	ProductFourthWeb: [{"name":"ProductAttribute02","type":"String","cardinality":1,"isExpandedPanel":null},{"name":"ProductAttribute03","type":"String","cardinality":1,"isExpandedPanel":null},{"name":"ColorCode","type":"String","cardinality":1,"isExpandedPanel":null}],
	ReportsRefferalCustomerHeader: [{"name":"CustomerCode","type":"String","cardinality":1,"isExpandedPanel":null}],
	ReportsAdminRefferalPendingHeader: [{"name":"CustomerCode","type":"String","cardinality":1,"isExpandedPanel":null}],
	ReportsAdminRefferalPendingDetail: [{"name":"OrderNumber","type":"String","cardinality":1,"isExpandedPanel":null}]
};

export class ScreenInputHelper {
  public static getScreenInputValue(screenName: string, inputName: string, value: string): any {
    switch (this.getScreenInputType(screenName, inputName)) {
      case "String":
        return value;
      case "Boolean":
        return value.toLowerCase() === "true";
      // TODO
    }

    return value;
  }

  private static getScreenInputType(screenName: string, inputName: string): string {
    const data = screenInputData[screenName]?.find((x) => x.Name === inputName);
    return data?.TypeName ? data.TypeName : "";
  }
}
